/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import SiteShell from './SiteShell.jsx'
import Team from '../components/Team.jsx'
import { ABOUT_PARAGRAPHS } from '../data/about.js'

export default function AboutPage() {
  return (
    <SiteShell variant="about">
      <section className="pg-about">
        <h1>درباره‌ی سکویا</h1>
        {ABOUT_PARAGRAPHS.map((p, i) => (
          <p key={i} className={i === 0 ? 'is-lead' : undefined}>
            {p}
          </p>
        ))}
        <div className="pg-about__cta">
          <a className="pg-cta" href="https://app.sequoia.fitness/new-order" target="_blank" rel="noopener">
            دریافت برنامه
          </a>
          <a className="pg-cta pg-cta--ghost" href="https://app.sequoia.fitness/sequoia-library" target="_blank" rel="noopener">
            ویدیوهای آموزشی
          </a>
        </div>
      </section>
      <Team />
    </SiteShell>
  )
}
